import { CompetitionCategoryType } from "../CompetitionCategoryType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const competitionCategoryTypeNameMap: Record<CompetitionCategoryType, LocalizedString> = {
	[CompetitionCategoryType.DogDartbee]: {
		[Locale.cs]: "Dog Dartbee",
		[Locale.en]: "Dog Dartbee",
	},
	[CompetitionCategoryType.FreestyleOpen]: {
		[Locale.cs]: "Freestyle – Open",
		[Locale.en]: "Freestyle – Open",
	},
	[CompetitionCategoryType.FreestyleStarters]: {
		[Locale.cs]: "Freestyle – Starters",
		[Locale.en]: "Freestyle – Starters",
	},
	[CompetitionCategoryType.ParalelTimeTrial]: {
		[Locale.cs]: "Paralel Time Trial",
		[Locale.en]: "Paralel Time Trial",
	},
	[CompetitionCategoryType.QuadrupedMen]: {
		[Locale.cs]: "Quadruped – Men",
		[Locale.en]: "Quadruped – Men",
	},
	[CompetitionCategoryType.QuadrupedWomen]: {
		[Locale.cs]: "Quadruped – Women",
		[Locale.en]: "Quadruped – Women",
	},
	[CompetitionCategoryType.Sptf1]: {
		[Locale.cs]: "SPTF 1",
		[Locale.en]: "SPTF 1",
	},
	[CompetitionCategoryType.Sptf2]: {
		[Locale.cs]: "SPTF 2",
		[Locale.en]: "SPTF 2",
	},
};
